import React from "react";

const DefaultQuestionnaire = ({ idEmpresa, questionnaire }) => {
  return (
    <div className="questionnaire-container">
      <h2>Cuestionario: {questionnaire}</h2>
      <p>ID de Empresa: {idEmpresa}</p>
      <p>Este cuestionario aún no ha sido implementado.</p>
    </div>
  );
};

export default DefaultQuestionnaire;
